import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, Button } from "react-bootstrap";
import { RootState } from "@reducers/rootReducer";
import { useCreateOpenRouterKeyMutation } from "@generated";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { handleAlert } from "@utils/helperFunctions";
import SmallSpinner from "@components/SmallSpinner/SmallSpinner";
import { OpenRouterKeyForm } from "../common/Form";
import { INITIAL_FORM_STATE, OpenRouterKeyFormState } from "../common/types";
import { formatOpenRouterKeyData } from "../common/helpers";
import "../style.css";

const New = (): JSX.Element => {
  const navigate = useNavigate();
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const [createOpenRouterKey] = useCreateOpenRouterKeyMutation();

  const [formState, setFormState] =
    useState<OpenRouterKeyFormState>(INITIAL_FORM_STATE);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showFailAlert, setShowFailAlert] = useState(false);

  const handleSave = () => {
    if (!formState.keyType) return;

    setLoading(true);
    const data = formatOpenRouterKeyData(formState);

    createOpenRouterKey({ slug: accountSlug, body: { data } })
      .unwrap()
      .then((res) => {
        const id = res?.data?.id;
        if (id) {
          navigate(`/admin/open_router_keys/${id}/edit`);
        } else {
          setErrorMessage("Failed to create open router key.");
          setShowFailAlert(true);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setErrorMessage(
          error?.data?.errors?.[0]?.detail || "An error occurred."
        );
        setShowFailAlert(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {handleAlert(
        showFailAlert,
        errorMessage,
        setShowFailAlert,
        "warning",
        ToastAlert
      )}
      <Card
        style={{
          padding: "16px",
          borderRadius: "4px",
          border: "1px solid var(--gray-3-stroke, #D7D7D7)",
          background: "var(--white, #FFF)",
          boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.15)",
        }}
      >
        <Card.Header
          style={{
            backgroundColor: "#fff",
            lineHeight: "40px",
            display: "block",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              className="accordianTitle"
              style={{ height: "40px", margin: "0", alignContent: "center" }}
            >
              <Button
                className="cancelButton"
                variant="secondary"
                onClick={() => navigate("/admin/open_router_keys")}
              >
                Cancel
              </Button>
              Add an Open Router Key
            </div>
            <div className="actionBtns">
              <Button
                className="regButton"
                onClick={handleSave}
                disabled={loading || !formState.keyType}
                variant="primary"
              >
                {loading ? <SmallSpinner /> : "Save"}
              </Button>
            </div>
          </div>
          <hr />
        </Card.Header>
        <Card.Body style={{ padding: "0px 16px 16px 16px" }}>
          <OpenRouterKeyForm
            formState={formState}
            setFormState={setFormState}
            editing={false}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default New;
